import React from 'react';
import ProjectItem from '@gp/components/ProjectItem';
import { getFormatNumPlus, getFormatPercentPlus } from '@gp/utils/common';
import { CONSTANT_TEXTS } from '@gp/constants/const';

/**
 * 获取表格配置项
 */
const getColumns = (
  toDetails: Function,
  year: string | undefined,
  month: string | undefined,
) => {
  const options = [
    {
      key: 'project',
      width: 240,
      header: 'Project',
      fixed: 'left',
      render: (cvm: any) => {
        return (
          <ProjectItem
            src={cvm?.project_detail?.img_url || ''}
            title={cvm?.project_detail?.name || '-'}
            platform={cvm?.project_detail?.platform}
            data={cvm}
            toDetails={toDetails}
          />
        );
      },
    },
    {
      key: 'bo',
      header: 'BO',
      align: 'left',
      width: 100,
      render: (cvm: any) => {
        let businessOwner = cvm?.project_detail?.bo || '';
        try {
          businessOwner =
            Object.values(JSON.parse(cvm?.project_detail?.bo))[0] ||
            businessOwner;
        } catch (error) {
          // console.warn(error);
        }
        return <div className="gp-word-break-word">{businessOwner || '-'}</div>;
      },
    },
    {
      key: 'total_budget',
      width: 160,
      align: 'right',
      header: (
        <div className="dbg-table-header-text">
          Approved Dev
          <br />
          Budget($)
        </div>
      ),
      render: (cvm: any) => {
        return getFormatNumPlus(cvm?.total_budget || '');
      },
    },
    {
      key: 'total_spent_to_date',
      width: 160,
      align: 'right',
      header: (
        <div className="dbg-table-header-text">
          Total Spent
          <br />
          to Date($)
        </div>
      ),
      render: (cvm: any) => {
        return getFormatNumPlus(cvm?.total_spent_to_date || '');
      },
    },
    {
      key: 'spent_to_date_percent',
      width: 222,
      align: 'right',
      header: (
        <div className="dbg-table-header-text">
          Total Spent to Date/
          <br />
          {CONSTANT_TEXTS.APPROVED_DEVELOPMENT_BUDGET_SIMPLE}
        </div>
      ),
      render: (cvm: any) => {
        return getFormatPercentPlus(cvm?.spent_to_date_percent || '', 2);
      },
    },
    {
      key: 'year_budget',
      width: 160,
      align: 'right',
      header: (
        <div className="dbg-table-header-text">
          {year || '-'}
          <br />
          Budget($)
        </div>
      ),
      render: (cvm: any) => {
        return getFormatNumPlus(cvm?.year_budget || '');
      },
    },
    {
      key: 'year_spent_to_date',
      width: 160,
      align: 'right',
      header: (
        <div className="dbg-table-header-text">
          {year || '-'} Spent
          <br />
          to Date($)
        </div>
      ),
      render: (cvm: any) => {
        return getFormatNumPlus(cvm?.year_spent_to_date || '');
      },
    },
    {
      key: 'year_spent_to_date_percent',
      width: 200,
      align: 'right',
      header: (
        <div className="dbg-table-header-text">
          {year || '-'} Spent to Date/
          <br />
          {year || '-'} Budget
        </div>
      ),
      render: (cvm: any) => {
        return getFormatPercentPlus(cvm?.year_spent_to_date_percent || '', 2);
      },
    },
    {
      key: 'month_spent',
      width: 160,
      align: 'right',
      header: (
        <div className="dbg-table-header-text">
          {year && month ? year + '.' + month : '-'}
          <br />
          Spent($)
        </div>
      ),
      render: (cvm: any) => {
        return getFormatNumPlus(cvm?.month_spent || '');
      },
    },
  ];

  return options;
};

export { getColumns };
